// Site-wide development banner. Persistent (not dismissible) so the
// "active development" framing rides every visit during the launch window.
//
// Sits above the page rather than overlaying it — the calendar and forms
// stay fully usable. Pairs with FeedbackButton to give visitors a clear
// path to respond ("we'd love to hear from you" → tap the floating button).

export function DevBanner() {
  return (
    <div
      role="status"
      className="bg-gradient-to-r from-amber-100 via-stone-100 to-amber-100 border-b border-amber-200 px-4 py-2 text-center text-sm text-stone-800"
    >
      <span className="font-medium">inkling.family is in active development</span>
      <span className="hidden sm:inline">, and we'd love to hear from you!</span>
      <span className="sm:hidden"> — feedback welcome ↘</span>
    </div>
  );
}
